import dynamic from "next/dynamic";
const AboutUsPage = dynamic(() => import("@/screens/AboutUs"));
const PageLayout = dynamic(() => import("@/screens/Layout/PageLayout"));
// import AboutUsPage from "@/screens/AboutUs";
// import PageLayout from "@/screens/Layout/PageLayout";

const AboutUs = ({ latestStoryData = null, latestVideoData = null }) => {
  return (
    <section className="m-4">
      <PageLayout
        latestStoryData={latestStoryData}
        latestVideoData={latestVideoData}
      >
        <AboutUsPage />
      </PageLayout>
    </section>
  );
};

export const getServerSideProps = async (ctx) => {
  const { logger } = await import("@/utils/logging/log-util");
  try {
    const { getLatestStoryVideoFeed, splitLatestStoryVideoFeed } = await import("@/handlers/content");
    const { getRedisApiKey, fetchRedisWrapper } = await import(
      "@/handlers/redisKey"
    );
    const { setPageTTL } = await import("@/utils/setPageTTL");
    const { getUnixTimeDaysAgo } = await import("@/utils/dateTimeFormat");
    const unixtime = getUnixTimeDaysAgo(15);

    //* get redis api key for each api
    const latestStoryVideoRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "story,video",
        unixtime,
      },
    });

    let [{ latestStoryData, latestVideoData }] = await Promise.all([
      fetchRedisWrapper(latestStoryVideoRedisKey, () =>
        getLatestStoryVideoFeed({
          page: 0,
          display: 5,
          unixtime,
        })
      ).then(splitLatestStoryVideoFeed),
    ]);

    // let headerCache = categoryNewsListData?.cache;
    setPageTTL(ctx, 15778476); //ttl: 6mo

    return {
      props: {
        latestStoryData,
        latestVideoData,
      },
    };
  } catch (error) {
    logger.error(error);
    return {
      notFound: true,
    };
  }
};

export default AboutUs;
